module.exports = __webpack_public_path__ + "img/Inspirational Motivator.29a671b0.svg";